import api from '@/services/base.service'

const methods = {
  getMotivos() {
    return api.get('/motivos')
  }
}

export default methods
